import type { TFunction } from 'i18next';
import {
  getPurchaseOrderActivityStatusColorClass,
  isPurchaseOrderActivityStatusCode,
} from '../config/purchase-order-activity-config';

type PurchaseOrderActivityStatusLabelProps = {
  value: string | null;
  t: TFunction<'purchaseOrder'>;
};

export function PurchaseOrderActivityStatusLabel({
  value,
  t,
}: PurchaseOrderActivityStatusLabelProps) {
  if (!value) {
    return <span>—</span>;
  }

  return (
    <span className='inline-flex items-center gap-2 font-semibold uppercase'>
      <span className={`size-3 rounded-full ${getStatusDotClassName(value)}`} />
      <span>{renderStatusLabel(value, t)}</span>
    </span>
  );
}

function renderStatusLabel(
  value: string | null,
  t: TFunction<'purchaseOrder'>,
): string {
  if (!value) {
    return '—';
  }

  if (isPurchaseOrderActivityStatusCode(value)) {
    return t(`status.${value}`);
  }

  return value;
}

function getStatusDotClassName(value: string) {
  return getPurchaseOrderActivityStatusColorClass(value, 'bg-gray-400');
}
